import * as SAGA from "./OrgManagerSaga";
import * as authActionTypes from "../Action/ActionTypes";

import { takeLatest } from "redux-saga/effects";
import {deliveryReportCoordinatesReportSaga, getTokenByTenantIdSaga} from "./OrgManagerSaga";


export function* watchOrgManager() {
  yield takeLatest(authActionTypes.ORG_ADD_TENANT, SAGA.addTenantSaga);
  yield takeLatest(authActionTypes.ORG_GET_ORG_POC, SAGA.getOrgPOCSaga);
  yield takeLatest(authActionTypes.ORG_ADD_ORG_POC, SAGA.addOrgPOCSaga);
  yield takeLatest(authActionTypes.ORG_EDIT_TENANT, SAGA.editTenantSaga);
  yield takeLatest(authActionTypes.GET_TOKEN, SAGA.getTokenByTenantIdSaga);
  yield takeLatest(authActionTypes.ORG_EDIT_ORGANIZATION, SAGA.editOrgSaga);
  yield takeLatest(authActionTypes.ORG_DELETE_TENANT, SAGA.deleteTenantSaga);
  yield takeLatest(authActionTypes.ORG_GET_ALL_TENANTS, SAGA.getTenantsSaga);
  yield takeLatest(authActionTypes.DELIVERY_REPORT, SAGA.deliveryReportSaga);
  yield takeLatest(authActionTypes.ORG_REMOVE_ORG_POC, SAGA.removeOrgPOCSaga);
  yield takeLatest(authActionTypes.ORG_UPDATE_ORG_POC, SAGA.updateOrgPOCSaga);
  yield takeLatest(authActionTypes.ORG_GET_USER_TOKEN, SAGA.getUserTokenSaga);
  yield takeLatest(authActionTypes.ORG_DOWNLOAD_USAGE, SAGA.downloadUsageSaga);
  yield takeLatest(authActionTypes.ORG_GET_TENANT_USER, SAGA.getTenantUserSaga);
  yield takeLatest(authActionTypes.ORG_GET_TENANT_BY_ID, SAGA.getTenantByIdSaga);
  yield takeLatest(authActionTypes.ORG_GET_ORGANIZATION_BY_ID, SAGA.getOrgByIdSaga);
  yield takeLatest(authActionTypes.COMPARE_POLYGONS_CHART, SAGA.comparePolygonsSaga);
  yield takeLatest(authActionTypes.ORG_UPDATE_TENANT_USER, SAGA.updateTenantUserSaga);
  yield takeLatest(authActionTypes.ORG_UPDATE_ORGANIZATION_USER, SAGA.updateOrgUserSaga);
  yield takeLatest(authActionTypes.ORG_GET_ORGANIZATION_USER, SAGA.getOrganizationUserSaga);
  yield takeLatest(authActionTypes.ORG_GET_ORGANIZATION_USAGE, SAGA.getOrganizationUsageSaga);
  yield takeLatest(authActionTypes.ORG_CHANGE_TENANT_PASSWORD, SAGA.changeTenantPassowrdSaga);
  yield takeLatest(authActionTypes.GET_TOKEN_FOR_ORGANIZATION, SAGA.getTokenForOrganizationSaga);
  yield takeLatest(authActionTypes.ORG_CHANGE_TENANT_ACTIVATION, SAGA.changeTenantActivationSaga);
  yield takeLatest(authActionTypes.ORG_MNG_GET_USER_TOKEN_BY_TENANT_ID, SAGA.getUserTokenByTenantIdSaga);
  yield takeLatest(authActionTypes.DELIVERY_COORDINATE_REPORT, SAGA.deliveryReportCoordinatesReportSaga);
}